export default {"src":"/_next/static/media/cicon4.06f69bd1.svg","height":56,"width":51};